export const setBaseAddressForUser = (lng,lat,textAddress) => ({
    type: 'SET_BASE_ADDRESS_FOR_USERS',lng,lat,textAddress
});